import styled from 'styled-components';
import {InfoBox} from 'shared/components/InfoBox';
import {LINE_HEIGHT} from 'components/customer/JobDashboard/helpers/useVariationRequest';
import {Icon} from 'shared/helpers';

interface VariationProps {
    $showAll: boolean;
    $lines?: number;
}

export const CommentBox = styled(InfoBox)<VariationProps>`
    position: relative;
    padding-bottom: 10px;
    z-index: ${({$showAll}) => ($showAll ? 2 : 'initial')};
    max-height: 115px;
    flex-grow: 1;
    display: flex;
    min-width: 140px;
    max-width: 460px;
`;

export const RelativeInfoBox = styled.div`
    flex-grow: 1;
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 10px;
`;

export const TextContainer = styled.div<VariationProps>`
    font-size: 1em;
    text-align: left;
    margin-top: 5px;
    padding: 0 10px;
    flex-grow: 1;
    overflow: hidden;
    line-height: ${LINE_HEIGHT}px;
    color: red;
    display: flex;
    height: ${({$lines = 0}) => $lines * LINE_HEIGHT}px;

    > div {
        resize: none;
        width: 100%;
        height: 100%;
        overflow: hidden;
        border: 0;
        padding: 0;
        background: white;
    }

    ${({$showAll, theme}) => {
        if ($showAll) {
            return `
            > div {
                top: 30px;
                position: absolute;
                right: -1px;
                left: -1px;
                padding: 10px;
                overflow-y: auto;
                height: 200px;
                border: 1px solid ${theme.colors.primary?.main};
                border-top: 0;
                border-bottom-left-radius: 8px;
                border-bottom-right-radius: 8px;
                width: initial;      
            }
        `;
        }
    }}
`;

const Button = styled.div<VariationProps>`
    border: 0;
    position: absolute;
    padding: 5px;
    background: white;
    cursor: pointer;
    padding: 0;
    margin: 0;

    right: 20px;
    top: ${({$showAll}) => ($showAll ? '222px' : 'calc(100% - 7px)')};
    z-index: 2;

    border-radius: 14px;
    line-height: 0;

    > img {
        width: 14px;
    }
`;

export const ReadMore = styled(Button)<VariationProps>`
    right: 20px;
`;

export const Title = styled.h1`
    dissplay: flex;
    align-items: center;
    justify-content: space-between;
    white-space: nowrap;
    padding: 5px 10px !important;

    > img {
        margin-left: 5px;
    }
`;

export const EditComment = styled(Icon)`
    width: 20px !important;
    cursor: pointer;
`;
